import { render, staticRenderFns } from "./PublicationComponent.vue?vue&type=template&id=2d2807ca&scoped=true&"
import script from "./PublicationComponent.vue?vue&type=script&lang=js&"
export * from "./PublicationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PublicationComponent.vue?vue&type=style&index=0&id=2d2807ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2807ca",
  null
  
)

export default component.exports